import ClientForm            from './components/client_management/client_form'
import ClientManagement      from './components/client_management/main'
import TransactionManagement from './components/transaction_management/main'
import TransactionHistory    from './components/transaction_history/main'

export { ClientManagement, ClientForm, TransactionManagement, TransactionHistory }
